module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-album"
  }, [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "227",
      "height": "227"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "425",
      "height": "425"
    }
  }), _vm._v(" "), _c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "canvasQr",
    attrs: {
      "width": "850",
      "height": "850"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "white-box sub-album-search column-content"
  }, [_c('span', {
    staticClass: "sub-id-txt span-14"
  }, [_vm._v("在")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.subSiteId),
      callback: function($$v) {
        _vm.subSiteId = $$v
      },
      expression: "subSiteId"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('span', {
    staticClass: "sub-name-txt span-14"
  }, [_vm._v("子站中销售")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    staticStyle: {
      "width": "54%"
    },
    attrs: {
      "placeholder": "请输入你想分销的专辑/声音名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.subsiteAlbumSearch()
      }
    },
    model: {
      value: (_vm.keyWord),
      callback: function($$v) {
        _vm.keyWord = $$v
      },
      expression: "keyWord"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        _vm.subsiteAlbumSearch()
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    staticClass: "white-box sub-list"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(tab, index) {
    return _c('el-tab-pane', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      key: tab.key,
      attrs: {
        "label": tab.txt,
        "name": index.toString()
      }
    }, [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.listData.list
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "contentId",
        "label": _vm.activeName == '1' ? '声音编号' : '专辑编号',
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "contentName",
        "label": _vm.activeName == '1' ? '声音名称' : '专辑名称',
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": _vm.activeName == '1' ? '声音封面' : '专辑封面',
        "width": "220"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('img', {
            staticClass: "cover",
            attrs: {
              "src": scope.row.contentCover,
              "width": "86"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": _vm.activeName == '1' ? '子站声音二维码' : '子站专辑二维码',
        "width": "144"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.hasQRcode(scope.row)) ? _c('el-popover', {
            attrs: {
              "trigger": "hover",
              "placement": "left"
            }
          }, [_c('div', {
            staticClass: "preQr"
          }, [_c('p', [_vm._v(_vm._s(("" + (scope.row.contentName))))]), _vm._v(" "), _c('img', {
            attrs: {
              "src": scope.row.qrCodeUrl
            }
          }), _vm._v(" "), _c('p', [_vm._v("可使用手机扫码，查看子站在手机上的展示效果")])]), _vm._v(" "), _c('div', {
            staticClass: "name-wrapper column-content qr-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_c('img', {
            staticClass: "qrImg",
            attrs: {
              "src": scope.row.qrCodeUrl
            }
          })])]) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "分销人",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            style: ({
              color: _vm.hasQRcode(scope.row) ? '' : '#f66549'
            })
          }, [_vm._v(_vm._s(scope.row.ownerDesc))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "handle",
        "label": "操作",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.hasQRcode(scope.row)) ? _c('div', {
            staticClass: "operate-button"
          }, [_c('el-button', {
            directives: [{
              name: "clipboard",
              rawName: "v-clipboard:copy",
              value: (("" + (_vm.activeName=='1'?scope.row.trackUrl:scope.row.albumUrl))),
              expression: "`${activeName=='1'?scope.row.trackUrl:scope.row.albumUrl}`",
              arg: "copy"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:success",
              value: (_vm.onCopy),
              expression: "onCopy",
              arg: "success"
            }, {
              name: "clipboard",
              rawName: "v-clipboard:error",
              value: (_vm.onError),
              expression: "onError",
              arg: "error"
            }],
            staticClass: "copy-url",
            attrs: {
              "type": "text",
              "size": "small"
            }
          }, [_vm._v("复制链接")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                _vm.downloadQr(scope.row.qrCodeUrl, scope.row.contentName)
              }
            }
          }, [_vm._v("保存二维码")])], 1) : _vm._e()]
        }
      }])
    })], 1)], 1)
  })), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.listData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.listData.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.listData, "curPage", $event)
      }
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-382f57ba","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/subStation/subAlbum.vue
// module id = 934
// module chunks = 1